module.exports = __webpack_public_path__ + "18dda92adf15cef8ad7734dc75882791.png";